import { render, staticRenderFns } from "./takvim.vue?vue&type=template&id=14083aa8&scoped=true&"
import script from "./takvim.vue?vue&type=script&lang=js&"
export * from "./takvim.vue?vue&type=script&lang=js&"
import style0 from "./takvim.vue?vue&type=style&index=0&id=14083aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14083aa8",
  null
  
)

export default component.exports